import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { apiRoutes } from 'config/apiRoutes'
import { useToast, useAxiosPrivate } from 'shared/hooks'
import { queryKeys } from 'config/queryKeys'

type UseProductTransferProps = {
	id: number | undefined
	clear: () => void
}

export const useProductTransfer = ({ id, clear }: UseProductTransferProps) => {
	const queryClient = useQueryClient()
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: productTransfer, isPending: productTransferPending } = useMutation({
		mutationFn: (targetId: string) =>
			axiosPrivate.post(apiRoutes.bookingProductTransfer(id?.toString() as string), {
				target_booking_id: targetId
			}),
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Products transfered')
			})()

			if (id) {
				queryClient.invalidateQueries({ queryKey: queryKeys.bookings.detail(id.toString()) })
			}
			clear()
		},
		onError: (err: any) => {
			useToast({
				type: 'error',
				message: err.response?.data?.target_booking_id?.[0] ?? t('Something went wrong')
			})()
		}
	})

	return {
		productTransfer,
		productTransferPending
	}
}
